/**
 * API base URL: sirf frontend .env se — REACT_APP_API_URL.
 * Fallback: localhost:5000 (dev).
 */

export function getApiBaseUrl(): string {
  return 'https://api.lukewestbrookmanhattan.com';
  // const env = process.env.REACT_APP_API_URL;
  // if (env) {
  //   const base = env.replace(/\/$/, '');
  //   debugLog('Using REACT_APP_API_URL', { env, base, apiUrl: base + (base.endsWith('/api') ? '' : '/api') });
  //   return base;
  // }
  // const base = 'http://localhost:5000';
  // debugLog('Fallback: localhost:5000 (REACT_APP_API_URL not set)', { base, apiUrl: base + '/api' });
  // return base;
}

export function getApiUrl(): string {
  const base = getApiBaseUrl();
  return base + (base.endsWith('/api') ? '' : '/api');
}
